import { h } from "preact";
import { useState, useRef, useEffect } from "preact/hooks";
import { CSSTransition } from "react-transition-group";
import ProductFormContent from "../product-form-content";
import useProduct from "../../helpers/useProduct/useProduct";

export default function ProductUpsellContent({
  open,
  id,
  productId,
  initialVariantId,
  idPrefix,
  addToCartProperties,
  onTotalChange,
  onVariantChange,
}) {
  // Delay the open transition until product data is cached, so the form
  // renders at full height on its first frame instead of jumping mid-animation
  const [productData] = useProduct(open ? productId : null);
  const [height, setHeight] = useState(0);
  const nodeRef = useRef();
  const roRef = useRef(null);

  useEffect(() => {
    return () => roRef.current?.disconnect();
  }, []);

  return (
    <CSSTransition
      mountOnEnter={true}
      unmountOnExit={true}
      in={open && !!productData}
      nodeRef={nodeRef}
      classNames="product-upsell__content-"
      onEntering={() => {
        if (!nodeRef.current) return;
        const inner = nodeRef.current.firstElementChild;
        if (!inner) return;
        roRef.current = new ResizeObserver(() => {
          if (nodeRef.current) setHeight(nodeRef.current.scrollHeight);
        });
        roRef.current.observe(inner);
      }}
      onEntered={() => {
        roRef.current?.disconnect();
        roRef.current = null;
      }}
      onExited={() => {
        roRef.current?.disconnect();
        roRef.current = null;
      }}
      addEndListener={(done) => {
        const node = nodeRef.current;
        if (!node) return;
        const onEnd = (event) => {
          if (event.target !== node || event.propertyName !== "height") return;
          node.removeEventListener("transitionend", onEnd);
          done();
        };
        node.addEventListener("transitionend", onEnd, false);
      }}
    >
      <div
        className="product-upsell__content"
        id={id}
        ref={nodeRef}
        style={{ "--height": `${height}px` }}
      >
        <div className="product-upsell__content-inner">
          <ProductFormContent
            productId={productId}
            initialVariantId={initialVariantId}
            idPrefix={idPrefix}
            optionsStyle="default"
            addonLimit={1}
            smallMonogram={true}
            showAtcPrice={false}
            truncateOptions={true}
            addToCartProperties={addToCartProperties}
            onTotalChange={onTotalChange}
            onVariantChange={onVariantChange}
          />
        </div>
      </div>
    </CSSTransition>
  );
}
